import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    width: 730px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    };
  `}
`;

export const MethodsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
`;

export const Description = styled.p`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
    line-height: ${theme.v2.font.lineHeight.text};
    text-align: center;
  `}
`;

export const AlertWrapper = styled.div`
  margin: 0 auto;
  max-width: 640px;
  margin-bottom: 40px;
`;

export const Divider = styled.hr`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.v2.colors.feedback.canceledPure};
    width: 100%;
  `}
`;
